import { useTranslation } from 'react-i18next';

type Lookup = (key: string, options?: { defaultValue?: string }) => string;

/** Translated hub, tab and sub-tab names (`nav:hubs.*`). Keys are dynamic, so ids are the fallback. */
export function useHubLabels() {
  const { t } = useTranslation('nav');
  const tr = t as unknown as Lookup;
  return {
    hub: (hub: string) => tr(`hubs.${hub}.label`, { defaultValue: hub }),
    description: (hub: string) => tr(`hubs.${hub}.description`, { defaultValue: '' }),
    tab: (hub: string, tab: string) => tr(`hubs.${hub}.tabs.${tab}`, { defaultValue: tab }),
    sub: (hub: string, tab: string, sub: string) => tr(`hubs.${hub}.subs.${tab}.${sub}`, { defaultValue: sub }),
  };
}
